// ios H5 桥接 
function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) { 
    return callback(WebViewJavascriptBridge); 
  } else  
  if (window.WVJBCallbacks) {
   return window.WVJBCallbacks.push(callback); 
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';

  document.documentElement.appendChild(WVJBIframe);

  setTimeout(function() { 
    document.documentElement.removeChild(WVJBIframe) 
  }, 0)
}

export default setupWebViewJavascriptBridge